import React, { useEffect, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  GetAgentAction,
  GetCatalogAction,
} from "../../Redux/action/SettingAction";
import Message from "../../Icon/Message";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const CatalogueBrochurelistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [CatalogueBrochurelist, setCatalogueBrochurelist] = useState([]);

  const [table_load, setTable_load] = useState(false);

  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    dispatch(GetCatalogAction(data));
    // fetchData(page, pagination.limit);
  };

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    dispatch(GetCatalogAction({ page: 1, limit: newLimit }));
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditCatalogandBrochure/${params.row.id}`);
        };
        return (
          <Tooltip title="Edit Organization">
            {" "}
            <IconButton onClick={handleEditActionClick}>
              <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "university_name",
      headerName: "University name",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row?.university?.name)}</div>;
      },
    },
    {
      field: "folder_name",
      headerName: "Folder name",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        return <div>{toTitleCase(params.row.folderId?.name)}</div>;
      },
    },
  ];

  const CatalogueBrochurelistState = useSelector(
    (state) => state.setting?.catalog?.data
  );

  useEffect(() => {
    // console.log(CatalogueBrochurelistState?.pagination)
    if (CatalogueBrochurelistState) {
      // const { data, pagination } = CatalogueBrochurelistState;
      // setRows(data);
      setPagination(CatalogueBrochurelistState?.pagination);
    }
  }, [CatalogueBrochurelistState]);
  //(CatalogueBrochurelistState, "catalog data");

  useEffect(() => {
    dispatch({ type: "GetCatalogList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    dispatch(GetCatalogAction(data));
  }, []);

  useEffect(() => {
    const updatedData = CatalogueBrochurelistState?.data?.map(
      ({ _id, ...rest }) => ({
        id: _id,
        ...rest,
      })
    );
    setCatalogueBrochurelist(updatedData);
    setTable_load(false);
  }, [CatalogueBrochurelistState]);

  return (
    <div>
      {loading ? (
        <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "24px",
          color: "#007bff",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            overflow: "hidden",
            backgroundColor: "transparent",
          }}
        >
          <div style={{ width: "100%", height: "100%",justifyContent:"center",display:"flex",alignItems:"center" }}>
            <img
              src="/assest/Group.png" // Your image URL
              alt="Loading..."
              style={{ width: "75%", height: "75%", objectFit: "contain" }}
            />
          </div>

          <CircularProgress
            size={100}
            sx={{
              color: ThemeColor.NAVYBLUE, // Customize the loader color
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          />
        </div>
      </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={6} md={5} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Catalogue/Brochure List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} md={7} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                >
                  Action
                </OutlineCustomButton>
                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") === "user") && (
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    onClick={() => navigate("/CAE/AddCatalogueBrochure")}
                  >
                    Add Catalogue
                  </CustomButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={CatalogueBrochurelist ? CatalogueBrochurelist : []}
              columns={columns}
              loading={table_load}
              minTableWidth="100%"
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
        </>
      )}
    </div>
  );
};

function CatalogueBrochurelist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    dispatch(GetCatalogAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<CatalogueBrochurelistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default CatalogueBrochurelist;
